import {
  MASAN_DEALER_NAV_ITEMS,
  PV_NAV_ITEMS,
  SHARED_NAV_ITEMS,
} from '../constants/nav-items';
import { t } from '../i18n';
import { NavItem } from '../types';

interface NavigationBarConfig {
  tenant: string;
  logged: boolean;
  isLoyaltyMember: boolean;
  showNotificationItem: boolean;
}

const getNavByTenant = (tenant: string): NavItem[] => {
  switch (tenant) {
    case 'phongvu':
      return PV_NAV_ITEMS;
    case 'masan-dealer':
      return MASAN_DEALER_NAV_ITEMS;
    default:
      return SHARED_NAV_ITEMS;
  }
};

export const getNavItems = (config: NavigationBarConfig): NavItem[] => {
  const { tenant, logged, isLoyaltyMember, showNotificationItem } = config;
  let _navItems = getNavByTenant(tenant);
  if (!logged) {
    _navItems = _navItems.filter((nav) => nav.anonymous);
  }

  if (logged && !isLoyaltyMember) {
    _navItems = _navItems.filter((nav) => nav.contentName != 'viewLoyalty');
  }
  return _navItems
    .filter(
      (nav) =>
        !nav.showByConfiguration ||
        (nav.showByConfiguration && showNotificationItem),
    )
    .map((item) => ({ ...item, text: t(item.text) }));
};
